import React, { memo } from "react";

import { getVehicleImage, getVehicleName, getVehiclePlate } from "../helpers";
import { VehicleWizardSceneProps } from "../types";

/** Redak vozila (fotografija, naziv, registracija) — kontekst u karticama scena. */
const VehicleRow: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  return (
    <div className="flex items-center gap-3 p-3">
      <div className="flex items-center justify-center w-16 h-10 rounded-sm bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden flex-shrink-0">
        <img src={getVehicleImage(vehicleInfo)} alt="" className="w-16 object-contain" />
      </div>
      <div className="min-w-0">
        <div className="text-[0.7rem] font-semibold text-slate-700 truncate">{getVehicleName(vehicleInfo)}</div>
        <div className="text-[0.65rem] text-slate-400">{getVehiclePlate(vehicleInfo)}</div>
      </div>
    </div>
  );
};

export default memo(VehicleRow);
